module.exports = __webpack_public_path__ + "b61ff8f21c8a21b630ba1383cff67b19.pdf";